module.exports = __webpack_public_path__ + "static/media/img_1.cd3f1bdc.png";